import Cover, { COVER_TYPE } from './Cover';

export default Cover;
export { COVER_TYPE };
